import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AccountPlan } from '../../../accounting/model/account-plan';
import { AccountPlanService } from '../../../accounting/service/data/account-plan.service';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import {
  AdjustmentKind,
  AdjustmentKindToString,
  ArticleTimeUnitKind,
  ArticleTimeUnitKindToString,
  ArticleUnit,
  ArticleUnitKindToString,
} from '../../model/const/enums';
import { ActivatedRoute } from '@angular/router';
import { standardCommand } from '../../../core/model/command';
import { ArticleGroup } from '../../model/article-group';
import { ArticleGroupService } from '../../service/data/article-group.service';

@Component({
    selector: 'app-article-group-form',
    templateUrl: './article-group-form.component.html',
    styleUrls: ['./article-group-form.component.scss'],
    providers: [DeleteFormCommandHandler, FormCommandHandlerResolver, { provide: DataService, useExisting: ArticleGroupService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleGroupFormComponent extends FormComponentBase<ArticleGroup> {
  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    service: ArticleGroupService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, service, messageService, navigation, commandDispatcher, handlerResolver);
    this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
  }

  protected createModel(): ArticleGroup {
    return new ArticleGroup();
  }

  protected getFormGroup(): FormGroup {
    return this._fb.group({
      id: this._fc.createHidden(this.dataContext.id),
      name: this._fc.createMandatory('ARTICLE_GROUP.NAME', this.dataContext.name),
      isRent: this._fc.create('ARTICLE_GROUP.IS_RENT', this.dataContext.isRent, null, null, 'ARTICLE_GROUP.HELP_TEXT.IS_RENT'),
    });
  }
}
